import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import winRateImage from "../../../Assets/Images/winRate.svg";
import { Skeleton } from "Components/ui/skeleton";
const WinChart = () => {
  const { winRate, getWinRateLoading, getWinRateSuccess, getWinRateError } =
    useSelector((state) => state.ChallengePerformanceReducer);
  const { challengeStageInfoLoading } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );

  const [data, setData] = useState([]);

  useEffect(() => {
    if (winRate?.winRatesByWeekArray?.length > 0)
      setData(
        winRate?.winRatesByWeekArray.map((item, index) => {
          return {
            week: `Week ${item?.weekNumber}`,
            value: item?.winRate.toFixed(2),
          };
        })
      );
  }, [winRate]);

  return (
    <div className="chart_cont border-2 bg-background  border-border-darkNew rounded-lg h-full  p-4 flex flex-col justify-between xl:min-w-[30%] w-full">
      <div className="flex justify-between w-full border-b-2 border-b-border-darkNew pb-4  mb-4">
        <div className="text-base">Win Rate</div>
        {getWinRateLoading || challengeStageInfoLoading ? (
          <Skeleton className="w-16 h-6 " />
        ) : (
          <div className="text-lg font-N_Bold">
            {winRate?.winRate
              ? winRate?.winRate?.toLocaleString() + " %"
              : "0%"}
          </div>
        )}
      </div>
      {getWinRateLoading || challengeStageInfoLoading ? (
        <Skeleton className="w-full h-full " />
      ) : winRate?.winRate > 0 ? (
        <ResponsiveContainer
          width="105%"
          height="100%"
          style={{
            marginLeft: "-5%",
          }}
        >
          <BarChart data={data}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#40aeee" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#40aeee" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="week"
              fontFamily="N_Light"
              stroke="#ffffff30"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              stroke="#ffffff30"
              fontSize={12}
              fontFamily="N_Light"
              tickLine={false}
              axisLine={false}
              tickFormatter={(value) => `${value}%`}
              domain={[0, "dataMax + 20"]}
            />
            <Bar dataKey="value" radius={10} fill="url(#colorUv)">
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    Math.max(...data.map((o) => o.value)) == entry?.value
                      ? "url(#colorUv)"
                      : "#ffffff10"
                  }
                />
              ))}
              <LabelList
                dataKey="value"
                position="top"
                content={({ x, y, width, height, value }) => {
                  if (value != 0)
                    return (
                      <>
                        <rect
                          x={x + width / 2 - 25}
                          y={y - 26}
                          width="50"
                          height="20"
                          fill="transparent"
                          rx="5"
                          ry="5"
                        />
                        <text
                          x={x + width / 2}
                          y={y - 10 - 5}
                          fill={
                            Math.max(...data.map((o) => o.value)) == value
                              ? "var(--primary)"
                              : "#ffffff30"
                          }
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fontSize={12}
                        >
                          {`${value}%`}
                        </text>
                      </>
                    );
                }}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="text-base text-white-opacity h-full flex flex-col gap-0 items-center justify-center cursor-pointer ">
          <div className="font-N_Medium text-2xl ">No Data Found!</div>
          <div className="font-N_Light text-base w-full max-w-[18rem]  text-center">
            You haven't participated in any trade yet.
          </div>
        </div>
      )}
    </div>
  );
};

export default WinChart;
